import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'agencies': [],
  'agenciesSelected': '',
  'loading': false,
};

export const wtsAgencies = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_AGENCIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENCIES]: (state, action) => ({
      ...state,
      'loading': false,
      'agencies': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_AGENCIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'agencies': [],
      'agenciesSelected': '',
    }),
    [ActionTypes.CHANGE_WTS_AGENCY_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'agenciesSelected': action.payload,
    }),
    [ActionTypes.FETCHING_WTS_AGENCIES_DEALER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AGENCIES_DEALER]: (state, action) => ({
      ...state,
      'loading': false,
      'agencies': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_AGENCIES_DEALER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'agencies': [],
      'agenciesSelected': '',
    }),
  })(state, action);
};
